import { render, staticRenderFns } from "./newsletterGS.vue?vue&type=template&id=85373482"
import script from "./newsletterGS.vue?vue&type=script&lang=js"
export * from "./newsletterGS.vue?vue&type=script&lang=js"
import style0 from "./newsletterGS.vue?vue&type=style&index=0&id=85373482&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports